// extracted by mini-css-extract-plugin
export var externalLink = "_90-0";
export var internalLinkLabel = "_90-1";